import messages from "messages";

/**
 * get phq-9 rank by score
 */
export default function getPHQ9ScoreRank(arg: number) {
  const res: {
    type: string;
    noticeable: boolean;
  } = {
    type: messages.severe,
    noticeable: false,
  };
  if (arg < 5) {
    res.type = messages.nonminimal;
  } else if (arg < 10) {
    res.type = messages.mild;
  } else if (arg < 15) {
    res.type = messages.moderate;
  } else if (arg < 20) {
    res.type = messages.moderatelySevere;
    res.noticeable = true;
  } else {
    res.type = messages.severe;
    res.noticeable = true;
  }

  return res;
}
